import ViewItemReceive from "../../../../components/@documents/item_receives/ViewItemReceive";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function ItemReceiveViewPage() {

    return (
        <ViewItemReceive 
            routeType={routeTypes.workstation}
        />
    )
}